import React from 'react';
import { View, Text } from 'react-native';
import { luxColors, DNAIcon } from '../..';
import DNAButton from '../controls/DNAButton/DNAButton';
var ICON_NAME;
(function (ICON_NAME) {
    ICON_NAME["information"] = "information";
    ICON_NAME["success"] = "checkbox-marked-circle";
    ICON_NAME["warning"] = "alert";
    ICON_NAME["error"] = "alert-circle";
    ICON_NAME["loading"] = "timer-sand-empty";
})(ICON_NAME || (ICON_NAME = {}));
function GenericToast(props) {
    const styles = {
        wrapper: {
            width: props.width,
            flex: 1,
            flexDirection: 'row',
            paddingTop: 10,
            paddingLeft: 10,
            paddingBottom: 10,
            paddingRight: 8,
            backgroundColor: luxColors.info.primary,
        },
        icon: {
            width: 20,
            height: 20,
            color: luxColors.toastIcon[props.status],
        },
        title: {
            fontSize: 13,
            lineHeight: 24,
            marginRight: 12,
            marginLeft: 12,
            alignSelf: 'center',
            fontWeight: 'bold',
        },
    };
    return (<View testID="toast-container" style={styles.wrapper}>
      <DNAIcon testID={`icon-${ICON_NAME[props.status]}`} name={ICON_NAME[props.status]} style={styles.icon}/>
      <Text testID="toast-message" style={styles.title}>{props.title}</Text>
      {props.actionConfig &&
        <DNAButton status="primary" appearance="ghost" context="minimum" onPress={props.actionConfig.callback}>
            {props.actionConfig.actionTitle}
          </DNAButton>}
    </View>);
}
export default GenericToast;
//# sourceMappingURL=GenericToast.js.map